import * as React from "react";
import { useEffect, useState } from "react";
import Slider from "rc-slider";
import { useResources } from "contexts/resource-context";
import {
    ExtraPagePageSize,
    NotebookDefaultMaxNumberOfExtraPages,
    NotebookMaxNumberOfExtraPagesForB5,
    NotebookMinNumberOfExtraPages,
} from "svg/constants";

type NotebookPageSliderProps = {
    calendarSize: string;
    customNumberOfEndPages: number;
    updateCustomNumberOfEndPages: (customNumberOfEndPages: number) => void;
};

const NotebookPageSlider = ({
    calendarSize,
    customNumberOfEndPages,
    updateCustomNumberOfEndPages,
}: NotebookPageSliderProps) => {
    const {
        Notebook_NumberOfPagesTitle,
        Notebook_CurrentNumberOfExtraPages,
    } = useResources();

    const NotebookMaxNumberOfExtraPages =
        calendarSize.toUpperCase() === "B5"
            ? NotebookMaxNumberOfExtraPagesForB5
            : NotebookDefaultMaxNumberOfExtraPages;

    const [sliderValue, setSliderValue] = useState<number>(
        NotebookMaxNumberOfExtraPages - customNumberOfEndPages,
    );
    const numberOfExtraPagesStringSplitIndex = Notebook_CurrentNumberOfExtraPages.indexOf(
        "{0}",
    );

    useEffect(() => {
        if (
            sliderValue !==
            NotebookMaxNumberOfExtraPages - customNumberOfEndPages
        ) {
            setSliderValue(
                NotebookMaxNumberOfExtraPages - customNumberOfEndPages,
            );
        }
    }, [customNumberOfEndPages]);

    return (
        <div style={{ paddingBottom: "5px" }}>
            <div style={{ paddingBottom: "20px" }}>
                <p>
                    <strong>{Notebook_NumberOfPagesTitle}</strong>
                </p>
            </div>
            <Slider
                onChange={(value) => {
                    setSliderValue(value);
                }}
                onAfterChange={() => {
                    updateCustomNumberOfEndPages(
                        NotebookMaxNumberOfExtraPages - sliderValue,
                    );
                }}
                defaultValue={
                    NotebookMaxNumberOfExtraPages - customNumberOfEndPages
                }
                step={ExtraPagePageSize}
                min={NotebookMinNumberOfExtraPages}
                max={NotebookMaxNumberOfExtraPages}
            />
            <div style={{ textAlign: "center" }}>
                <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                    <b>{`${sliderValue} / ${NotebookMaxNumberOfExtraPages}`}</b>
                </div>
                {Notebook_CurrentNumberOfExtraPages.substring(
                    0,
                    numberOfExtraPagesStringSplitIndex,
                )}
                <b
                    dangerouslySetInnerHTML={{
                        __html: `${
                            NotebookMaxNumberOfExtraPages - sliderValue
                        }`,
                    }}></b>
                {Notebook_CurrentNumberOfExtraPages.substring(
                    numberOfExtraPagesStringSplitIndex + 3,
                    Notebook_CurrentNumberOfExtraPages.length,
                )}
            </div>
        </div>
    );
};

export default NotebookPageSlider;
